import { ref } from 'vue';

export default function useFileDropzone() {
  const fileInput = ref<HTMLInputElement | null>(null);
  const isDragging = ref(false);

  const openFileDialog = () => {
    fileInput.value?.click();
  };

  const onDragEnter = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    isDragging.value = true;
  };

  const onDragLeave = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    isDragging.value = false;
  };

  const onDragOver = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    isDragging.value = true;
  };

  const onDrop = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    isDragging.value = false;

    return e.dataTransfer?.files || null;
  };

  return {
    fileInput,
    isDragging,
    openFileDialog,
    onDragEnter,
    onDragLeave,
    onDragOver,
    onDrop,
  };
}
